<div class="card smaller configuration-panel-card k-mt-5">
  <div class="card-header">Texteditor</div>
  <div class="card-body">
    @if (this.contentElement()) {
      <kendo-editor
        [iframeCss]="iframeStyles"
        class="text-editor"
        [plugins]="editorPlugins"
        [schema]="customSchema"
        [value]="toEditorHtml(this.contentElement() ?? '')"
        (valueChange)="contentChanged($event)"
        #editor
      >
        <kendo-toolbar>
          <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
          </kendo-toolbar-buttongroup>
          <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
          <kendo-toolbar-dropdownlist
            kendoEditorFontFamily
            [data]="editorFontFamilies"
          ></kendo-toolbar-dropdownlist>
        </kendo-toolbar>
      </kendo-editor>
    }
  </div>
</div>
